module.exports = __webpack_public_path__ + "static/media/teamNFT3.c57f1d42.png";